import { render, staticRenderFns } from "./InsuranceDetails.vue?vue&type=template&id=56e4141e&"
import script from "./InsuranceDetails.vue?vue&type=script&lang=js&"
export * from "./InsuranceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports